import { useEffect, useState } from 'react';
import config from './config';

const apiBase = (process.env.REACT_APP_API_URL || config.API_URL || '').replace(/\/+$/, '');

export default function PagoCompletado() {
  const [estado, setEstado] = useState('cargando'); // cargando | pagado | pendiente | fallido | desconocido
  const [info, setInfo]   = useState(null);

  useEffect(() => {
    const id = new URLSearchParams(window.location.search).get('id');
    if (!id) { setEstado('desconocido'); return; }

    fetch(`${apiBase}/pagos/resultado/${id}`)
      .then(r => r.json())
      .then(data => {
        if (data.success) {
          setInfo(data);
          setEstado(data.estatus === 'pagado' ? 'pagado' : data.estatus === 'fallido' ? 'fallido' : 'pendiente');
        } else {
          setEstado('desconocido');
        }
      })
      .catch(() => setEstado('desconocido'));
  }, []);

  const views = {
    cargando: {
      bg: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)',
      icon: null,
      spinner: true,
      title: 'Verificando pago...',
      msg: 'Por favor espera un momento.',
    },
    pagado: {
      bg: 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)',
      iconBg: '#16a34a', icon: '✓',
      title: '¡Pago recibido!',
      msg: 'Tu pago fue procesado exitosamente.\nRecibirás confirmación en tu correo en breve.',
    },
    pendiente: {
      bg: 'linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)',
      iconBg: '#d97706', icon: '⏳',
      title: 'Pago en proceso',
      msg: 'Tu pago está siendo procesado.\nTe notificaremos cuando se confirme.',
    },
    fallido: {
      bg: 'linear-gradient(135deg, #fff1f2 0%, #ffe4e6 100%)',
      iconBg: '#ef4444', icon: '✕',
      title: 'Pago no completado',
      msg: 'No fue posible procesar tu pago.\nPor favor intenta de nuevo o contáctanos.',
    },
    desconocido: {
      bg: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
      iconBg: '#64748b', icon: '?',
      title: 'Estado desconocido',
      msg: 'No pudimos verificar el estado de tu pago.\nContacta a Activo Contadores para confirmar.',
    },
  };

  const v = views[estado] || views.desconocido;

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: v.bg, fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif', padding: '24px' }}>
      <div style={{ background: '#fff', borderRadius: '16px', padding: '40px 32px', boxShadow: '0 8px 40px rgba(0,0,0,0.10)', textAlign: 'center', maxWidth: '420px', width: '100%' }}>

        {v.spinner
          ? <div style={{ width: '48px', height: '48px', border: '4px solid #e5e7eb', borderTop: '4px solid #0060aa', borderRadius: '50%', margin: '0 auto 20px', animation: 'spin 0.8s linear infinite' }} />
          : <div style={{ width: '64px', height: '64px', background: v.iconBg, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px', fontSize: '28px', color: '#fff' }}>{v.icon}</div>
        }

        <h1 style={{ fontSize: '1.6rem', margin: '0 0 10px', fontWeight: '800', color: '#111' }}>{v.title}</h1>

        {info && (info.monto || info.concepto) && (
          <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '12px 16px', margin: '0 0 16px', textAlign: 'left' }}>
            {info.monto  && <p style={{ margin: '0 0 4px', color: '#374151', fontSize: '14px' }}><strong>Monto:</strong> ${Number(info.monto).toLocaleString('es-MX', { minimumFractionDigits: 2 })} MXN</p>}
            {info.concepto && <p style={{ margin: 0, color: '#374151', fontSize: '14px' }}><strong>Concepto:</strong> {info.concepto}</p>}
          </div>
        )}

        <p style={{ color: '#4b5563', fontSize: '1rem', lineHeight: '1.7', margin: '0 0 24px', whiteSpace: 'pre-line' }}>{v.msg}</p>

        <div style={{ borderTop: '1px solid #e5e7eb', margin: '0 0 20px' }} />

        <p style={{ color: '#6b7280', fontSize: '13px', lineHeight: '1.8', margin: '0 0 16px' }}>
          ¿Tienes alguna pregunta sobre tu pago?<br />
          <strong style={{ color: '#374151' }}>Activo Contadores</strong><br />
          <a href="mailto:agustin@activocontadores.com" style={{ color: '#0060aa', textDecoration: 'none' }}>agustin@activocontadores.com</a><br />
          664 494 0143
        </p>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
          <span style={{ color: '#9ca3af', fontSize: '11px' }}>Pago procesado por</span>
          <img src="/openpay-logo.jpg" alt="Openpay" style={{ height: '16px', objectFit: 'contain' }} />
        </div>

      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
